<template>
  <div class="main-holder">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      class="news-item"
      v-for="item in list"
      :key="item.id"
    >
      <div class="news-content">
        <div>
          <div class="img-holder">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
            <div class="cat-wrapper">
              <div class="cat-meta">{{ item.sub_category.name }}</div>
            </div>
          </div>
        </div>
        <div class="meta-wrapper">
          <div class="title limited-text">
            {{ item.title }}
          </div>
          <div class="date-wrapper">
            <span class="date">{{ handleDate(item.pub_date) }},</span>
            <span class="date" style="padding-left: 0.44em">{{
              handleTime(item.pub_date)
            }}</span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FourthBar",
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      d: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-holder {
  position: relative;
  width: var(--width-content);
  display: grid;
  padding-top: 7em;
  grid-template-columns: 1fr 1.3fr 1.3fr 1fr;
  column-gap: 2.5rem;
  grid-template-areas:
    "card-1  card-2   card-2   card-3"
    "card-4  card-2   card-2   card-5"
    "card-6  card-2   card-2   card-7"
    "card-6  card-12  card-12  card-7"
    "card-8  card-12  card-12  card-9"
    "card-10 card-12  card-12  card-11";

  .news-item {
    height: auto;
    width: 100%;
    position: relative;
    padding-bottom: 4.375rem;

    &:nth-child(1) {
      grid-area: card-1;
    }
    &:nth-child(2) {
      grid-area: card-2;
    }
    &:nth-child(3) {
      grid-area: card-3;
    }
    &:nth-child(4) {
      grid-area: card-4;
    }
    &:nth-child(5) {
      grid-area: card-5;
    }
    &:nth-child(6) {
      grid-area: card-6;
    }
    &:nth-child(7) {
      grid-area: card-7;
    }
    &:nth-child(8) {
      grid-area: card-8;
    }
    &:nth-child(9) {
      grid-area: card-9;
    }
    &:nth-child(10) {
      grid-area: card-10;
    }
    &:nth-child(11) {
      grid-area: card-11;
    }
    &:nth-child(12) {
      grid-area: card-12;
    }

    &:hover {
      img {
        transform: scale(1.14);
      }
    }

    .news-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .img-holder {
      width: 100%;
      height: auto;
      border-radius: 4px;
      padding-top: 59.09%; /* 22:13 Aspect Ratio */
      position: relative;
      overflow: hidden;

      .img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        transition: all 0.4s ease;
      }

      .cat-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        background-color: var(--background-color);
        height: 1.6em;
        font-family: Open Sans;

        .cat-meta {
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0.375rem;
          }
        }
      }
    }

    .title {
      font-family: Roboto;
      font-size: 1.25em;
      font-weight: 500;
      line-height: 1.5em;
      padding-top: 0.625rem;

      // background: linear-gradient(45deg, transparent 33%, rgba(var(--secondary-bg), 0.7) 66%, var(--primary-font-color));
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .date-wrapper {
      font-weight: 300;
      font-size: 0.875em;
      padding-top: 0.75em;
      opacity: 0.8;
      font-family: Open Sans;
    }
  }
}

@media screen and (max-width: 1200px) {
  .main-holder {
    grid-template-columns: 1fr 1.1fr 1.1fr 1fr;
  }
}

@media screen and (max-width: 1000px) {
  .main-holder {
    display: block;

    .news-item {
      display: flex;
      margin: 0px;
      padding-bottom: 2.5rem;
      .news-content {
        flex-direction: row;
        justify-content: flex-start;

        .img-holder {
          padding-top: 0;
          width: 18.75em;
          height: 12.5em;
        }

        .meta-wrapper {
          display: flex;
          padding-left: 1.6em;
          justify-content: space-between;
          flex-direction: column;

          .title {
            padding-top: 0;
            font-size: 1.5em;
            line-height: 1.375em;
          }

          .date-wrapper {
            display: flex;
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }

      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        .news-content {
          flex-direction: row-reverse;
        }

        .meta-wrapper {
          align-items: flex-end;
          padding-right: 1.6em;
          padding-left: 0;

          .title {
            text-align: left;
          }

          .date-wrapper {
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 993px) {
  .main-holder {
    .news-item {
      &:nth-child(2),
      &:last-child {
        .title {
          text-align: center;
        }

        .date-wrapper {
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main-holder {
    display: block;
    .news-item {
      display: flex;
      padding-bottom: 2.5rem;
      .news-content {
        flex-direction: row;
        justify-content: flex-start;
        margin-left: 5px;
        margin-right: 5px;

        .img-holder {
          width: 12em;
          height: 8em;
        }
        .cat-wrapper {
          height: 1.35em;
        }
        .meta-wrapper {
          display: flex;
          padding-left: 0.8em;
          justify-content: space-between;
          flex-direction: column;

          .title {
            padding-top: 0;
            font-size: 1.1em;
            line-height: 1.2em;
          }

          .date-wrapper {
            display: flex;
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }

      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        .news-content {
          flex-direction: row-reverse;
        }

        .meta-wrapper {
          align-items: flex-end;
          padding-right: 0.8em;
          padding-left: 0;

          .title {
            text-align: left;
          }

          .date-wrapper {
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 392px) {
  .main-holder {
    width: 100% !important;
  }
}
@media screen and (max-width: 375px) {
  .main-holder {
    display: block;
    width: 100% !important;

    .news-item {
      display: flex;
      padding-bottom: 1.5em;

      .news-content {
        flex-direction: row;
        justify-content: flex-start;
        margin-left: 12px;
        margin-right: 12px;

        .img-holder {
          width: 9em;
          height: 6.5em;
        }

        .meta-wrapper {
          display: flex;
          padding-left: 0.7em;
          justify-content: space-between;
          flex-direction: column;

          .title {
            padding-top: 0;
            font-size: 1em;
            line-height: 1.2em;
          }

          .date-wrapper {
            display: flex;
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.7em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }

      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        .news-content {
          flex-direction: row-reverse;
        }

        .meta-wrapper {
          align-items: flex-end;
          padding-right: 0.8em;
          padding-left: 0;

          .title {
            text-align: left;
          }

          .date-wrapper {
            font-weight: 300;
            font-size: 0.875em;
            padding-top: 0.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }
    }
  }
}
</style>
